import React from "react";

const Download = props => {
	return (
		<div style={{display: "inline-flex",
			alignSelf:"center"}}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 -256 1950 1950"
				id="svg2"
				version="1.1"
				// width="100%"
				height="1em"
				width="1em"
				style={{top: ".125em",
					position: "relative"}}
				// viewBox="0 0 8 11"
			>
				<defs id="defs10" />
				<g transform="matrix(1,0,0,-1,15.186441,1451.0169)" id="g4">
					<path
						d="m 1280,608 q 0,14 -9,23 -9,9 -23,9 h -224 v 352 q 0,13 -9.5,22.5 -9.5,9.5 -22.5,9.5 H 800 q -13,0 -22.5,-9.5 Q 768,1005 768,992 V 640 H 544 q -13,0 -22.5,-9.5 Q 512,621 512,608 q 0,-14 9,-23 L 873,233 q 9,-9 23,-9 14,0 23,9 l 351,351 q 10,12 10,24 z M 1920,384 Q 1920,225 1807.5,112.5 1695,0 1536,0 H 448 Q 263,0 131.5,131.5 0,263 0,448 q 0,130 70,240 70,110 188,165 -2,30 -2,43 0,212 150,362 150,150 362,150 156,0 285.5,-87 129.5,-87 188.5,-231 71,62 166,62 106,0 181,-75 75,-75 75,-181 0,-76 -41,-138 130,-31 213.5,-135.5 Q 1920,518 1920,384 z"
						id="path6"
						style={{fill: "currentColor"}}
					/>
				</g>
			</svg>
		</div>
	);
};

export default Download;



// WEBPACK FOOTER //
// ./src/components/icons/Download/index.js